import React from 'react';
import { UserGuideChapter } from '../../types/userGuide';
import { Lock } from 'lucide-react';

interface GuideContentProps {
  chapter: UserGuideChapter | undefined;
}

export const GuideContent: React.FC<GuideContentProps> = ({ chapter }) => {
  if (!chapter) {
    return (
      <div className="flex-1 flex items-center justify-center p-8 text-gray-500">
        Select a chapter to begin reading.
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-6 md:p-10 bg-gray-50">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        
        {!chapter.is_accessible && (
          <div className="bg-yellow-50 border-b border-yellow-200 p-4 flex items-start space-x-3">
            <Lock className="w-5 h-5 text-yellow-600 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-yellow-800">
                Not available for your role
              </h4>
              <p className="text-sm text-yellow-700 mt-1">
                You are viewing this section for reference, but your current role does not have permission to access these features. Roles cannot be self-escalated.
              </p>
            </div>
          </div>
        )}

        <div className="p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">{chapter.title}</h1>
          <div 
            className="prose prose-blue max-w-none prose-headings:text-gray-900 prose-a:text-blue-600 hover:prose-a:text-blue-500"
            dangerouslySetInnerHTML={{ __html: chapter.content }}
          />
        </div>
      </div>
    </div>
  );
};
